import { useSubscribedState } from 'nordic/page/store';

export const useUser = () => useSubscribedState().user || { loggedIn: false };
